export default __webpack_public_path__ + "static/media/Company.08904073.svg";